import { schema } from "normalizr";
import { FDMCompanyRecordClass } from "records/company";

export const Company = new schema.Entity(
    "companies",
    {},
    {
        idAttribute: "_id",
    }
);

(Company as any).record = FDMCompanyRecordClass;
